// update along with app/lib/enums/change_log_user_type.py
const CHANGE_LOG_USER_TYPE = {
  SCRAPER: 'SCRAPER',
  GDSN: 'GDSN',
  CUT_AND_DRY: 'CUT_AND_DRY',
  FSA: 'FSA',
};

export default CHANGE_LOG_USER_TYPE;
